module.exports = __webpack_public_path__ + "static/media/branded-play-button.a66217b4.png";